import { useRouter } from 'next/router';
import { useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { redirectToMyloUrl } from '../../../Utils/redirections';
import AnchorCoverTag from '../../StoreHomePage/AnchorCoverTag';
import { MenuArrow, MenuListTitle } from './styled';

export default function MenuTitle(props) {
  const {
    title,
    activeIndex,
    index,
    subCategoryLength,
    categoryClickHandler,
    category,
    ltwoCat,
    l2ActiveIndex,
    parentingDrawer,
    childCategory,
    childlevel,
    cardEffect,
    index_blurred,
    trackOrderHandler,
  } = props;

  const router = useRouter();
  const [lowOpacity, setLowOpacity] = useState('');
  const classIndexBlurred = index_blurred ? 'blurred' : '';
  const brands = ['Mylo Care', 'Mylo Baby'];
  return (
    <MenuListTitle
      ltwoCat={ltwoCat || childCategory}
      parentingDrawer={parentingDrawer || subCategoryLength === 0}
      childlevel={childlevel}
      className={
        index == cardEffect?.index && childlevel > 0
          ? `${cardEffect?.class} ${classIndexBlurred}`
          : `${classIndexBlurred}`
      }
      noDeeplink={category?.key}
      // onClick={(e) => {
      //     if (e.target.id != "arrow") {
      //         e.preventDefault();
      //         e.stopPropagation();
      //     }
      // }}
    >
      {/* {category?.image && (
                <MenuTitleImage src={category?.image} loading="lazy" alt="" />
            )} */}
      <p
        onClick={
          title == 'HOME'
            ? () => {
                setLowOpacity('lowOpacity');
                setTimeout(() => {
                  redirectToMyloUrl('');
                }, [200]);
                setTimeout(() => {
                  setLowOpacity('');
                }, [2000]);
              }
            : subCategoryLength == 0 && !category?.downloadApp
              ? () => {
                  router.push(category?.key);
                }
              : () => {
                  if (title === 'Mylo Care' || title === 'Mylo Baby')
                    categoryClickHandler(category, index);
                }
        }
      >
        {brands.includes(title) ? (
          <AnchorCoverTag url={category?.deeplink}>
            <img src={category?.image} className="brandImg" alt="" />
          </AnchorCoverTag>
        ) : (
          title?.toLowerCase()
        )}
      </p>
      {subCategoryLength > 0 ? (
        activeIndex == index || (l2ActiveIndex == index && ltwoCat) ? (
          <MenuArrow src={images.arrowDownForward} alt="MenuArrow" id="arrow" />
        ) : (
          <MenuArrow
            src={images.arrowDownForward}
            alt="MenuArrow"
            id="arrow"
            className="down"
          />
        )
      ) : null}
      {/* {title == "HOME" ? (
                <TrackOrder trackOrderHandler={trackOrderHandler} />
            ) : null} */}
    </MenuListTitle>
  );
}
